import React from 'react';
import { Rocket } from 'lucide-react';

export default function ComingSoon({ moduleName }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4 reveal-mount">
      <div className="glass border border-border rounded-2xl p-8 max-w-md w-full">
        <div className="w-12 h-12 rounded-xl bg-accent/10 text-accent grid place-items-center mx-auto mb-4">
          <Rocket size={24} />
        </div>
        <p className="text-xs font-600 uppercase tracking-wider text-text-muted mb-2">Em breve</p>
        <h2 className="text-xl font-700 text-text mb-2">
          {moduleName || 'Novidade a caminho'}
        </h2>
        <p className="text-sm text-text-secondary leading-relaxed">
          Estamos finalizando este módulo para a próxima atualização do Feed ERP.
          Enquanto isso, o restante do sistema segue disponível normalmente.
        </p>
      </div>
    </div>
  );
}
